'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('../utils');

function defaultValueFormatter(value, state) {
  var _getProps = (0, _utils.getProps)(state),
      showPrefix = _getProps.showPrefix,
      prefix = _getProps.prefix,
      showSuffix = _getProps.showSuffix,
      suffix = _getProps.suffix;

  return '' + (showPrefix && prefix || '') + (value || '') + (showSuffix && suffix || '');
}

exports.default = {
  defaultValueFormatter: defaultValueFormatter
};
module.exports = exports['default'];